'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.horsesListStore = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _DiffusionServiceUtils = require('./../utils/DiffusionServiceUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var newHorseElementsSelector = '.js-diffusionHorsesList:not(.js-PC-subscribed)';
var subscribedHorseseClass = 'js-PC-subscribed';

var HorsesListStore = function () {
    function HorsesListStore() {
        _classCallCheck(this, HorsesListStore);

        this.horsesList = [];
    }

    _createClass(HorsesListStore, [{
        key: 'getHorsesList',
        value: function getHorsesList() {
            return this.horsesList;
        }

        // TODO: move to private function, utils or static method (JIRA: PC-4559)
        /* eslint-disable class-methods-use-this */

    }, {
        key: 'getNotSubscribedHorses',
        value: function getNotSubscribedHorses() {
            var diffusionHorsesNodeList = (0, _jquery2.default)(newHorseElementsSelector).toArray();
            var notSubscribedHorses = diffusionHorsesNodeList.map(_DiffusionServiceUtils.diffusionServiceUtils.getElementDiffusionData.bind(_DiffusionServiceUtils.diffusionServiceUtils));

            diffusionHorsesNodeList.forEach(function (element) {
                element.classList.add(subscribedHorseseClass);
            });

            return notSubscribedHorses;
        }
        /* eslint-enable class-methods-use-this */

    }, {
        key: 'updateHorsesData',
        value: function updateHorsesData() {
            var notSubscribedHorses = this.getNotSubscribedHorses();

            this.horsesList = this.horsesList.concat(notSubscribedHorses);

            return notSubscribedHorses;
        }
    }]);

    return HorsesListStore;
}();
// TODO: export constructor and instantiate it in place of usage (JIRA: PC-4559)
/* eslint-disable import/prefer-default-export */


var horsesListStore = exports.horsesListStore = new HorsesListStore();


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/stores/HorsesListStore.js
// module id = 924
// module chunks = 0